var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSolidStar = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.173 4.576h-3.75L6.182.71A.237.237 0 005.73.709L4.487 4.576H.737a.237.237 0 00-.144.425l2.99 2.316-1.244 3.827a.236.236 0 00.365.265l3.251-2.362 3.252 2.362a.236.236 0 00.365-.265L8.327 7.317 11.317 5a.237.237 0 00-.144-.424z",
  fill: "#FFF",
  fillRule: "nonzero"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSolidStar);
export default ForwardRef;